module.exports = "/images/pay.svg?a5870c9902ad0efc3a38b7cba73e9f90";